import { ApolloProvider } from "@apollo/client";
import { Layer } from "@carbon/react";
import {
  AuthModeProvider,
  ImportExportAuthGuard,
  InternationalizationProvider as ImportExportInternationalizationProvider,
  SpecificationPage,
} from "@flaminem/import-export";

import { AppUser } from "src/authentication/appUser.ts";
import OverlayLoading from "src/components/DataStates/OverlayLoading";
import PageError from "src/components/Errors/PageError";
import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { useGetBlacklistTypesSchemasQuery } from "src/graphql/anti-fraud/queries/blacklistTypes/BlacklistTypesSchemasQuery";
import { getImportExportApolloClient } from "src/graphql/import-export/apolloClient.ts";
import { useLocale, useT } from "src/internationalization";
import { useCaseTypes } from "src/providers/CaseTypesProvider.tsx";

export const SpecificationsPage = () => {
  const { locale } = useLocale();
  const t = useT();
  const { caseTypes } = useCaseTypes();
  const { data: blacklistTypes, loading, error } = useGetBlacklistTypesSchemasQuery();

  if (loading) {
    return <OverlayLoading />;
  }

  if (error) {
    return <PageError title={error.title} description={error.message} />;
  }

  return (
    <ApolloProvider client={getImportExportApolloClient()}>
      <AuthModeProvider authMode="bearer">
        <ImportExportAuthGuard getToken={() => AppUser.getAccessToken() ?? null}>
          <ImportExportInternationalizationProvider locale={locale}>
            <PageStack>
              <PageHeader className="mb-5">
                {t("webcomponent.import.specification.title")}
              </PageHeader>
              <Layer level={1}>
                <SpecificationPage caseTypes={caseTypes} blacklistTypes={blacklistTypes} />
              </Layer>
            </PageStack>
          </ImportExportInternationalizationProvider>
        </ImportExportAuthGuard>
      </AuthModeProvider>
    </ApolloProvider>
  );
};
